import React from "react";

const PasswordIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={19}
        height={20}
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.25 7.75V5.75C5.25 2.989 6.489 0.75 9.25 0.75C12.011 0.75 13.25 2.989 13.25 5.75V7.75M9.25 13.5V13M13.25 13.5V13M5.25 13.5V13M0.75 15.55V10.95C0.75 9.83 0.75 9.27 0.968 8.843C1.15957 8.46632 1.46554 8.16 1.842 7.968C2.27 7.751 2.83 7.751 3.95 7.751H14.55C15.67 7.751 16.23 7.751 16.658 7.968C17.0343 8.15974 17.3403 8.46569 17.532 8.842C17.75 9.27 17.75 9.83 17.75 10.95V15.55C17.75 16.67 17.75 17.23 17.532 17.658C17.3403 18.0343 17.0343 18.3403 16.658 18.532C16.23 18.75 15.67 18.75 14.55 18.75H3.95C2.83 18.75 2.27 18.75 1.842 18.532C1.46569 18.3403 1.15974 18.0343 0.968 17.658C0.75 17.231 0.75 16.671 0.75 15.55Z"
            stroke="white"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PasswordIcon;
